import { useState, useEffect, createRef } from 'react';
import {
	getSettings,
	watchSettings,
	unwatchSettings,
	setSetting
} from '../utils/eventViewerSettings';
import toJSON from '../utils/toJSON';

export default function AdditionalSources() {
	const [sources, setSources] = useState(getSettings().additionalSources);
	const addSourceInput = createRef();

	useEffect(() => {
		const settingsChangeHandler = (newSettings) => {
			if (toJSON(newSettings.additionalSources) !== toJSON(sources)) {
				setSources(newSettings.additionalSources);
			}
		};
		watchSettings(settingsChangeHandler);
		return function cleanup() {
			unwatchSettings(settingsChangeHandler);
		};
	});

	const addSourceFormSubmitHandler = (event) => {
		event.preventDefault();
		if (addSourceInput.current) {
			const source = addSourceInput.current.value;
			addSourceInput.current.value = '';
			if (sources.indexOf(source) === -1) {
				const newSources = [...sources, source];
				setSetting('additionalSources', newSources);
			}
		}
	};
	const removeSource = (source) => {
		const sourcesClone = [...sources];
		const index = sourcesClone.indexOf(source);
		if (index !== -1) {
			sourcesClone.splice(index, 1);
			setSetting('additionalSources', sourcesClone);
		}
	};

	return (
		<>
			<h3>Additional Sources</h3>
			<ul>
				{sources.map((source) => (
					// eslint-disable-next-line react/jsx-indent
					<li key={source}>
						{source}
						<button
							type="button"
							className="btn btn-sm p-2 ml-4"
							onClick={() => removeSource(source)}
						>
							X
						</button>
					</li>
				))}
			</ul>
			<form onSubmit={addSourceFormSubmitHandler}>
				<div className="row">
					<div className="col col-md-8">
						<input
							ref={addSourceInput}
							className="form-control"
							placeholder="Global Source Path"
						/>
					</div>
					<div className="col col-md-4">
						<button type="submit" className="btn w-100">
							Add Source
						</button>
					</div>
				</div>
			</form>
		</>
	);
}
AdditionalSources.propTypes = {};
